import React from 'react';
import './Timeline.css';

const Timeline = () => {
  const steps = [
    { step: 'Step 01', title: 'Free Counselling Session', desc: 'Talk to our expert counsellors who evaluate your NEET score, budget, and goals to map the best path forward.' },
    { step: 'Step 02', title: 'Personalised College Shortlist', desc: 'We curate a ranked list of colleges — India or abroad — that best match your profile, preference, and budget.' },
    { step: 'Step 03', title: 'Application & Documentation', desc: 'Our team assists with every document — transcripts, SOP, recommendation letters, and university submissions.' },
    { step: 'Step 04', title: 'Pre-Departure', desc: 'Complete support, accommodation, forex guidance, and a thorough pre-departure orientation included.' },
    { step: 'Step 05', title: 'Admission Confirmed 🎓', desc: 'You arrive and begin your MBBS journey. Our team continues to support you throughout the full course.' }
  ];

  return (
    <section className="section" id="process">
      <div className="section-inner">
        <div className="tl-outer">
          <div className="reveal">
            <div className="sec-label">The Process</div>
            <h2 className="sec-title">Your 5-Step Path to an MBBS Seat</h2>
            <p className="sec-sub">A clear, structured process designed to take you from aspiration to admission with expert support at every stage.</p>
            <a href="#home" className="btn-primary" style={{ marginTop: '1.8rem', display: 'inline-flex' }}>
              Apply Free Today →
            </a>
          </div>
          <div className="tl-right reveal">
            <div className="tl-line"></div>
            {steps.map((item, idx) => (
              <div className="tl-item" key={idx}>
                <div className="tl-dot"></div>
                <div className="tl-step">{item.step}</div>
                <div className="tl-title">{item.title}</div>
                <div className="tl-desc">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;